import Parametres from '../../types/api/Parametres';
import { Box, Button, Dialog, Stack } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteParametres, listParametres, upsertParametres } from '../../api/restaurant';
import ParametresForm from '../../forms/ParametresForm';
import YesNoPopup from '../Popups/YesNoPopup';
import AddIcon from '@mui/icons-material/Add';

interface parametresManagementProps {

}

enum ParametresFormType {
    add = 'add',
    edit = 'edit'
}

export function ParametresManagement(parametresManagementProps: parametresManagementProps) {

    const [parametres, setParametres] = useState<Parametres[]>([]);

    const [parametresForm, setParametresForm] = useState(false);
    const [parametresFormMode, setParametresFormMode] = useState<ParametresFormType>(ParametresFormType.add);
    const [parametresFormValues, setParametresFormValues] = useState<Parametres>({} as Parametres);

    const [toDeleteParametres, setToDeleteParametres] = useState<number[]>([]);
    const [removeParametresPopup, setRemoveParametresPopup] = useState(false);

    const openParametresEditionForm = (parametres: Parametres) => {
        setParametresFormValues(parametres);
        setParametresFormMode(ParametresFormType.edit);
        setParametresForm(true);
    }

    const openCreateParametresForm = () => {
        setParametresFormValues({
            id: -1,
            key: '',
            value: ''
        });
        setParametresFormMode(ParametresFormType.add);
        setParametresForm(true);
    };

    const openDeleteParametresConfirmation = (id: number) => {
        setToDeleteParametres([id]);
        setRemoveParametresPopup(true);
    };

    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 100,
            renderCell: (params: any) => {
                return (
                    <Box sx={{color: 'secondary.contrastText'}}>
                        {params.row.id}
                    </Box>
                )
            }
        },
        {
            field: 'key',
            headerName: 'Clé',
            width: 200,
            renderCell: (params: any) => {
                return (
                    <Box sx={{color: 'secondary.contrastText'}}>
                        {params.row.key}
                    </Box>
                )
            }
        },
        {
            field: 'value',
            headerName: 'Valeur',
            width: 200,
            renderCell: (params: any) => {
                return (
                    <Box sx={{color: 'secondary.contrastText'}}>
                        {params.row.value}
                    </Box>
                )
            }
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 200,
            renderCell: (params: any) => {
                return (
                    <Box>
						<Stack direction="row" spacing={1}>
							<Button
								onClick={()=>{openParametresEditionForm(params.row)}}
								variant="contained"
								startIcon={<EditIcon />}
							>
								Éditer
							</Button>
							<Button
								onClick={()=>{openDeleteParametresConfirmation(params.row.id)}}
								variant="contained"
								startIcon={<DeleteIcon />}
								color='error'
							>
								Supprimer
							</Button>
						</Stack>
					</Box>
                )
            }
        }
    ];

    const deleteSelectedParametres = async () => {
        const res = await deleteParametres(toDeleteParametres[0]);
        if(res && res.data){
            setToDeleteParametres([]);
            setRemoveParametresPopup(false);
            updateParametres();
        }
    };

    const updateParametres = async () => {
        const res = await listParametres();
        console.log(res);
        if(res && res.code === 200 && res.data){
            setParametres(res.data);
            console.log(res.data);
        }
    }

    const saveParametres = async (parametres: Parametres) => {
        const res = await upsertParametres(parametres);
        if(res && res.data){
            setParametresForm(false);
            updateParametres();
        }
    };

    useEffect(() => {
        updateParametres();
     }, []);


    return (
        <>
           <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{paddingY: 2}}>
				<Box></Box>
				<Button
					color='success'
					variant="contained"
					onClick={openCreateParametresForm}
					startIcon={<AddIcon />}
				>
					Créer
				</Button>
			</Stack>

			<DataGrid
				rows={parametres}
				sx={{ color: "primary.main" }}
				columns={columns}
				disableColumnMenu
				disableColumnSorting
				disableRowSelectionOnClick
				getRowId={(row) => row.id}
				initialState={{
					pagination: {
						paginationModel: { pageSize: 10, page: 0 },
					},
				}}
				localeText={{
					noRowsLabel: 'Aucun paramètre créé',
					MuiTablePagination: {
						labelRowsPerPage: 'Lignes par page :'
					}
				}}
				pageSizeOptions={[10, 25, 50]}
			/>

			<ParametresForm
				open={parametresForm}
                confirmLabel={
					parametresFormMode === ParametresFormType.add ? 'Créer' : parametresFormMode === ParametresFormType.edit ? 'Modifier' : 'Error'
				}
				save={saveParametres}
				baseParametres={parametresFormValues}
				updateParametres={setParametresFormValues}
				close={() => {
					setParametresForm(false);
				}}
			/>

			<Dialog open={removeParametresPopup}>
				<YesNoPopup
					message="Voulez-vous vraiment supprimer ce(s) paramètres ?"
					no={() => {
						setRemoveParametresPopup(false);
					}}
					yes={deleteSelectedParametres}
				/>
			</Dialog>
        </>
    );  
}

export default ParametresManagement;